import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Uhaul from './pages/Uhaul';
import ProductList from './pages/ProductList';
import Propane from './pages/Propane';
import AboutUs from './pages/AboutUs';
import TrailersandAccessories from './pages/TrailersandAccessories';
import WashersAndPumpsFinal from './pages/categoryPages/WashersAndPumpsFinal';
import HeavyEquipmentFinal from './pages/categoryPages/HeavyEquipmentFinal';
import FansFinal from './pages/categoryPages/FansFinal';
import MovingFinal from './pages/categoryPages/MovingFinal';
import ScrollToTop from './components/ScrollToTop';
import CementFinal from './pages/categoryPages/CementFinal';
import SawsFinal from './pages/categoryPages/SawsFinal';
import LawnAndGardenFinal from './pages/categoryPages/LawnAndGardenFinal';
import AugersFinal from './pages/categoryPages/AugersFinal';
import LaddersAndScaffoldingFinal from './pages/categoryPages/LaddersAndScaffoldingFinal';
import GeneratorsFinal from './pages/categoryPages/GeneratorsFinal';
import CompressorsFinal from './pages/categoryPages/CompressorsFinal';
import MiscFinal from './pages/categoryPages/MiscFinal';
import TablesAndChairsFinal from './pages/categoryPages/TablesAndChairsFinal';
import IndoorCareFinal from './pages/categoryPages/IndoorCareFinal';
import SodCutter from './pages/individualPages/SodCutter';
import LogSplitter from './pages/individualPages/LogSplitter';
import Thatcher from './pages/individualPages/Thatcher';
import Areator from './pages/individualPages/Areator';
import Edger from './pages/individualPages/Edger';
import LawnRoller from './pages/individualPages/LawnRoller';
import WalkBehindBlower from './pages/individualPages/WalkBehindBlower';
import BackpackBlower from './pages/individualPages/BackpackBlower';
import WheelLoader from './pages/individualPages/WheelLoader';
import TrackLoader from './pages/individualPages/TrackLoader';
import MiniExcavataur from './pages/individualPages/MiniExcavataur';
import MiniSkidSteer from './pages/individualPages/MiniSkidSteer';
import HandheldCutoffSaw from './pages/individualPages/HandheldCutoffSaw';
import ConcreteBuggy from './pages/individualPages/ConcreteBuggy';
import Compactor from './pages/individualPages/Compactor';
import JackHammer from './pages/individualPages/JackHammer';
import CementMixer from './pages/individualPages/CementMixer';
import HammerDrill from './pages/individualPages/HammerDrill';
import BullFloat from './pages/individualPages/BullFloat';
import WalkBehindSaw from './pages/individualPages/WalkBehindSaw';
import TileSaw from './pages/individualPages/TileSaw';
import Sawzall from './pages/individualPages/Sawzall';
import SawBlades from './pages/individualPages/SawBlades';
import HyhdraulicAuger from './pages/individualPages/HydraulicAuger';
import AugerBits from './pages/individualPages/AugerBits';
import AFrame from './pages/individualPages/AFrame';
import ExtensionLadder from './pages/individualPages/ExtensionLadder';
import IndoorScaffolding from './pages/individualPages/IndoorScaffolding';
import OutdoorScaffolding from './pages/individualPages/OutdoorScaffolding';
import ThreeInchGasPump from './pages/individualPages/ThreeInchGasPump';
import TwoInchGasPump from './pages/individualPages/TwoInchGasPump';
import TwoInchElectricPump from './pages/individualPages/TwoInchElectricPump';
import PressureWasher from './pages/individualPages/PressureWasher';
import ThreeInchHose from './pages/individualPages/ThreeInchHose';
import TwoInchHose from './pages/individualPages/TwoInchHose';
import LargeGenerators from './pages/individualPages/LargeGenerator';
import SmallGenerators from './pages/individualPages/SmallGenerators';
import TowBehindCompressor from './pages/individualPages/TowBehindCompressor';
import MediumCompressor from './pages/individualPages/MediumCompressor';
import SmallCompressor from './pages/individualPages/SmallCompressor';
import CarpetDryerFan from './pages/individualPages/CarpetDryerFan';
import DrumFan from './pages/individualPages/DrumFan';
import ExhaustFan from './pages/individualPages/ExhaustFan';
import CarpetCleaner from './pages/individualPages/CarpetCleaner';
import Dehumidifier from './pages/individualPages/Dehumidifier';
import FloorPolisher from './pages/individualPages/FloorPolisher';
import WallpaperSteamer from './pages/individualPages/WallpaperSteamer';
import KneeKicker from './pages/individualPages/KneeKicker';
import FoldingChairs from './pages/individualPages/FoldingChair';
import EightFootBanquetTables from './pages/individualPages/EightFootBanquetTables';
import SixFootBanquetTables from './pages/individualPages/SixFootBanquetTables';
import FiveFootRoundTables from './pages/individualPages/FiveFootRoundTables';
import PontoonTrailer from './pages/individualPages/PontoonTrailer';
import BlackEnclosedTrailer from './pages/individualPages/BlackEnclosedTrailer';
import BlueEnclosedTrailer from './pages/individualPages/BlueEnclosedTrailer';
import Hitch from './pages/individualPages/Hitch';
import LightAdapter from './pages/individualPages/LightAdapter';
import ExtraLargeBox from './pages/individualPages/ExtraLargeBox';
import LargeBox from './pages/individualPages/LargeBox';
import MediumBox from './pages/individualPages/MediumBox';
import SmallBox from './pages/individualPages/SmallBox';
import GrandWardrobeBox from './pages/individualPages/GrandWardrobeBox';
import ShortyWardrobeBox from './pages/individualPages/ShortyWardrobeBox';
import BubbleWrap from './pages/individualPages/BubbleWrap';
import WrappingPaper from './pages/individualPages/WrappingPaper';
import ApplianceDolly from './pages/individualPages/ApplianceDolly';
import DrywallJack from './pages/individualPages/DrywallJack';
import ExtensionCord from './pages/individualPages/ExtensionCord';
import AluminumBrake from './pages/individualPages/AluminumBrake';
import MetalDetector from './pages/individualPages/MetalDetector';
import Nailer from './pages/individualPages/Nailer';
import NoCategoriesList from './pages/NoCategoriesList';

ReactDOM.render(

  <Router>
    <ScrollToTop/>
    <Routes>
      <Route path='/' element={ <App/> }/>
      <Route path='/uhaul' element={ <Uhaul/> }/>
      <Route path='/catalog' element={ <ProductList/> }/>
      <Route path='/propane' element={ <Propane/> }/>
      <Route path='/about' element={ <AboutUs/> }/>

      <Route path='/catalog/lawnandgarden' element={ <LawnAndGardenFinal/> }/>
      <Route path='/catalog/sodcutter' element={ <SodCutter/> }/>
      <Route path='/catalog/logsplitter' element={ <LogSplitter/> }/>
      <Route path='/catalog/thatcher' element={ <Thatcher/> }/>
      <Route path='/catalog/areator' element={ <Areator/> }/>
      <Route path='/catalog/edger' element={ <Edger/> }/>
      <Route path='/catalog/lawnroller' element={ <LawnRoller/> }/>
      <Route path='/catalog/walkbehindblower' element={ <WalkBehindBlower/> }/>
      <Route path='/catalog/backpackblower' element={ <BackpackBlower/> }/>

      <Route path='/catalog/heavyequipment' element={ <HeavyEquipmentFinal/> }/>
      <Route path='/catalog/wheelloader' element={ <WheelLoader/> }/>
      <Route path='/catalog/trackloader' element={ <TrackLoader/> }/>
      <Route path='/catalog/miniexcavataur' element={ <MiniExcavataur/> }/>
      <Route path='/catalog/miniskidsteer' element={ <MiniSkidSteer/> }/>

      <Route path='/catalog/cement' element={ <CementFinal/> }/>
      <Route path='/catalog/cutoffsaw' element={ <HandheldCutoffSaw/> }/>
      <Route path='/catalog/concretebuggy' element={ <ConcreteBuggy/> }/>
      <Route path='/catalog/compactor' element={ <Compactor/> }/>
      <Route path='/catalog/jackhammer' element={ <JackHammer/> }/>
      <Route path='/catalog/cementmixer' element={ <CementMixer/> }/>
      <Route path='/catalog/hammerdrill' element={ <HammerDrill/> }/>
      <Route path='/catalog/bullfloat' element={ <BullFloat/> }/>
      <Route path='/catalog/walkbehindsaw' element={ <WalkBehindSaw/> }/>


      <Route path='/catalog/saws' element={ <SawsFinal/> }/>
      <Route path='/catalog/tilesaw' element={ <TileSaw/> }/>
      <Route path='/catalog/sawzall' element={ <Sawzall/> }/>
      <Route path='/catalog/sawblades' element={ <SawBlades/> }/>

      <Route path='/catalog/auger' element={ <AugersFinal/> }/>
      <Route path='/catalog/hydraulicauger' element={ <HyhdraulicAuger/> }/>
      <Route path='/catalog/augerbits' element={ <AugerBits/> }/>


      <Route path='/catalog/scaffoldingandladders' element={ <LaddersAndScaffoldingFinal/> }/>
      <Route path='/catalog/aframeladder' element={ <AFrame/> }/>
      <Route path='/catalog/extensionladder' element={ <ExtensionLadder/> }/>
      <Route path='/catalog/indoorscaffolding' element={ <IndoorScaffolding/> }/>
      <Route path='/catalog/outdoorscaffolding' element={ <OutdoorScaffolding/> }/>


      <Route path='/catalog/washersandpumps' element={ <WashersAndPumpsFinal/> }/>
      <Route path='/catalog/threeinchgaspump' element={ <ThreeInchGasPump/> }/>
      <Route path='/catalog/twoinchgaspump' element={ <TwoInchGasPump/> }/>
      <Route path='/catalog/twoinchelectricpump' element={ <TwoInchElectricPump/> }/>
      <Route path='/catalog/pressurewasher' element={ <PressureWasher/> }/>
      <Route path='/catalog/threeinchhose' element={ <ThreeInchHose/> }/>
      <Route path='/catalog/twoinchhose' element={ <TwoInchHose/> }/>

      <Route path='/catalog/generators' element={ <GeneratorsFinal/> }/>
      <Route path='/catalog/largegenerators' element={ <LargeGenerators/> }/>
      <Route path='/catalog/smallgenerators' element={ <SmallGenerators/> }/>


      <Route path='/catalog/compressors' element={ <CompressorsFinal/> }/>
      <Route path='/catalog/towbehindcompressor' element={ <TowBehindCompressor/> }/>
      <Route path='/catalog/mediumcompressors' element={ <MediumCompressor/> }/>
      <Route path='/catalog/smallcompressors' element={ <SmallCompressor/> }/>

      <Route path='/catalog/fans' element={ <FansFinal/> }/>
      <Route path='/catalog/carpetfan' element={ <CarpetDryerFan/> }/>
      <Route path='/catalog/drumfan' element={ <DrumFan/> }/>
      <Route path='/catalog/exhaustfan' element={ <ExhaustFan/> }/>

      <Route path='/catalog/indoorcare' element={ <IndoorCareFinal/> }/>
      <Route path='/catalog/carpetcleaner' element={ <CarpetCleaner/> }/>
      <Route path='/catalog/dehumidifier' element={ <Dehumidifier/> }/>
      <Route path='/catalog/floorpolisher' element={ <FloorPolisher/> }/>
      <Route path='/catalog/wallpapersteamer' element={ <WallpaperSteamer/> }/>
      <Route path='/catalog/kneekicker' element={ <KneeKicker/> }/>

      <Route path='/catalog/tablesandchairs' element={ <TablesAndChairsFinal/> }/>
      <Route path='/catalog/foldingchairs' element={ <FoldingChairs/> }/>
      <Route path='/catalog/8foottables' element={ <EightFootBanquetTables/> }/>
      <Route path='/catalog/6foottables' element={ <SixFootBanquetTables/> }/>
      <Route path='/catalog/5foottables' element={ <FiveFootRoundTables/> }/>

      <Route path='/catalog/trailers' element={ <TrailersandAccessories/> }/>
      <Route path='/catalog/pontoontrailer' element={ <PontoonTrailer/> }/>
      <Route path='/catalog/5x8enclosedtrailer' element={ <BlackEnclosedTrailer/> }/>
      <Route path='/catalog/6x12enclosedtrailer' element={ <BlueEnclosedTrailer/> }/>
      <Route path='/catalog/hitch' element={ <Hitch/> }/>
      <Route path='/catalog/lightadapter' element={ <LightAdapter/> }/>

      <Route path='/catalog/moving' element={ <MovingFinal/> }/>
      <Route path='/catalog/extralargebox' element={ <ExtraLargeBox/> }/>
      <Route path='/catalog/largebox' element={ <LargeBox/> }/>
      <Route path='/catalog/mediumbox' element={ <MediumBox/> }/>
      <Route path='/catalog/smallbox' element={ <SmallBox/> }/>
      <Route path='/catalog/grandwardrobebox' element={ <GrandWardrobeBox/> }/>
      <Route path='/catalog/shortywardrobebox' element={ <ShortyWardrobeBox/> }/>
      <Route path='/catalog/bubblewrap' element={ <BubbleWrap/> }/>
      <Route path='/catalog/wrappingpaper' element={ <WrappingPaper/> }/>

      <Route path='/catalog/misc' element={ <MiscFinal/> }/>
      <Route path='/catalog/appliancedolly' element={ <ApplianceDolly/> }/>
      <Route path='/catalog/drywalljack' element={ <DrywallJack/> }/>
      <Route path='/catalog/extensioncord' element={ <ExtensionCord/> }/>
      <Route path='/catalog/alumunimbrake' element={ <AluminumBrake/> }/>
      <Route path='/catalog/metaldetector' element={ <MetalDetector/> }/>
      <Route path='/catalog/nailer' element={ <Nailer/> }/>

      <Route path='/catalog/all' element={ <NoCategoriesList/> }/>


    </Routes>
  </Router>,

  document.getElementById('root')
);